import { FieldSelect } from '@/components/looker/field-select';
import { TaskPriority } from '@/task-manager/entities/task-priority';

export type TaskPriorityFilterProps = {
  value?: TaskPriority;
  onChange: (value?: TaskPriority) => void;
};

export function TaskPriorityFilter({
  value,
  onChange,
}: TaskPriorityFilterProps) {
  return (
    <FieldSelect
      data-testid="task-priority-filter"
      label="Priority"
      placeholder="Filter by priority"
      value={value}
      isClearable={true}
      options={Object.values(TaskPriority).map((value) => ({
        value,
      }))}
      onChange={(v) =>
        onChange(
          v
            ? Object.entries(TaskPriority).find(
                ([_, value]) => value === v,
              )?.[1]
            : undefined,
        )
      }
    />
  );
}
